import { IPublicClientApplication } from "@azure/msal-browser";
import { useAccount, useMsal } from "@azure/msal-react";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Avatar,
  Box,
  Menu,
  MenuItem,
  Stack,
  Theme,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { authMode, authRedirectUri } from "auth/utils/authSettings";
import EntaBreadcrumb from "common/breadcrumb/components";
import DrawerMenu from "common/components/DrawerMenu";
import EnvironmentsPopup from "common/components/EnvironmentsPopup";
import Loader from "common/components/Loader";
import usePopup from "common/hooks/usePopup";
import { useState } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuButton: {
      marginRight: theme.spacing(2),
    },
    menuIcon: {
      color: "#000",
    },
  })
);

const EntaAppbar = () => {
  const { anchorEl, handleClose, handleOpen, open } = usePopup();
  const [showMenu, setMenu] = useState<boolean>(false);
  const classes = useStyles();
  const { instance } = useMsal();
  const account = useAccount();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const isAuthenticated = !!account;
  const name = account?.name;

  const handleClickSignOut = (instance: IPublicClientApplication) => {
    instance
      .logoutRedirect({
        postLogoutRedirectUri: authRedirectUri,
      })
      .catch((e: any) => {
        console.error(e);
      });
  };

  // const handleClickSignIn = (instance: IPublicClientApplication) => {
  //   instance.loginRedirect().catch((e: any) => {
  //     console.error(e);
  //   });
  // };

  const avatarLetters = `${name?.split(" ")?.[0]?.[0] ?? ""} ${
    name?.split(" ")?.[1]?.[0] ?? ""
  }`;

  return (
    <>
      <DrawerMenu showMenu={showMenu} setMenu={setMenu} />
      <AppBar position="fixed" elevation={2}>
        <Toolbar>
          <IconButton
            edge="start"
            aria-label="menu"
            className={classes.menuButton}
            onClick={() => setMenu(true)}
            size="large"
          >
            <MenuIcon className={classes.menuIcon} />
          </IconButton>
          <Box flexGrow={1}>
            <EntaBreadcrumb />
          </Box>
          <Box>
            {isAuthenticated && (
              <>
                {isSmallDevice ? (
                  <IconButton
                    color="primary"
                    onClick={handleOpen}
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                  >
                    <AccountCircle />
                  </IconButton>
                ) : (
                  <Stack direction="row" spacing={1} alignItems="center">
                    {authMode === "b2c" && <EnvironmentsPopup />}
                    <IconButton onClick={handleOpen}>
                      <Avatar sx={{ fontSize: 14 }}>{avatarLetters}</Avatar>
                    </IconButton>
                  </Stack>
                )}
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  {authMode === "b2c" && isSmallDevice && (
                    <MenuItem>
                      <Stack direction="row" spacing={0} alignSelf={"start"}>
                        <EnvironmentsPopup />
                      </Stack>
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => handleClickSignOut(instance)}>
                    Sign Out
                  </MenuItem>
                </Menu>
              </>
            )}
          </Box>
        </Toolbar>
        <Loader />
      </AppBar>
    </>
  );
};

export default EntaAppbar;
